import Vue from 'vue'
import api from 'Plugins/api'
import { NOW_DATE, MIN_DATE, MAX_DATE, TravelVerificateType } from '@/business/Domain/use-cases/train-book-interactor'
import TrainBookInteractor from '@/business/Domain/use-cases/train-book-interactor'
import filters from 'Utils/filter'

const initialState = () => {
  return {
    fromStation: '', //出发城市
    toStation: '', //到达城市
    fromStationCode: '', //出发城市三字码
    toStationCode: '', //到达城市三字码
    fromStationCityId: '',
    toStationCityId:'',
    byTrainDate: NOW_DATE.date, //出发日期
    MIN_DATE: MIN_DATE.date, // 火车票流程（查询页 => trQuery、列表页 => trList、申请改签页 => ApplyAlter）最小可选日期
    MAX_DATE: MAX_DATE.date, // 火车票流程最大可选日期
    allTrains: true, // 是否包含距发车不到2hours的车次
    minRank: 1, // 差标等级
    needTrainType: false, // 只看高铁
    trainList: [], // 火车票列表
    feeList: [], // 服务费列表
    supplierCode: '',
    supplierId: '',
    supplierName: '',
    sellServiceCharge: '',
    violate: {}, // 本次违背信息
    '12306Info': {
      trainAccount: '', // 登录成功才赋值进来
      password: '',
      psgList: [], // 当前12306账号下的常旅客
    }, // 只在12306.vue文件中控制
    TrainDetail: {}, // 选择的车次信息
    SeatDetail: {}, // 选择的座席信息
    Ccsqd: {}, // 出差申请单
    path: '/tr/trEdit', // 指定火车车次详情页面(trDetail)选择座席后跳转的页面（出差申请单/改签）
    PageParameter: {
      IS12306Book: true,
      ISofflineBook: false,
      offline_title: '',
      offline_label: '',
      offline_tips: '',
      offline_icon: '',
      ISTgOfflineBook: false,
      tgOffline_title: '',
      tgOffline_label: '',
      tgOffline_tips: '',
      tgOffline_icon: '',
      sellServiceCharge: '',
      offline_sellServiceCharge: '',
      tgOffline_sellServiceCharge: '',
    },
    TravelVerificateType: TravelVerificateType.emp,
		
  }
}

const tr = {
  namespaced: true,

  state: {
    trSearchInfo: initialState(),
    travelerList: [],
    travelTips: {
      lastDate: '',
      depportCityid:'',
      arriveCityid:'',
    },
    subsequent:{}//隐藏火车，机票的退改签
  },
  getters: { //getters属性理解为所有组件的computed属性, 也就是计算属性 
    trSearchInfo: state => state.trSearchInfo,
    travelerList: state => state.travelerList,
    travelTips: (state) => {
      return state.travelTips
    },
  },
  mutations: {
    trSearchInfo (state, payload) {
      state.trSearchInfo = payload
    },
    travelerList (state, payload) {
      state.travelerList = payload
    },
    SET_VIOLATELIST (state, payload) {
      state.trSearchInfo.violate = {
        ...payload, 
        violateItem: state.trSearchInfo.TrainDetail.clzcStr 
      }
    },
    setSeatDetail (state, payload) {
      state.trSearchInfo.SeatDetail = payload
    },
    travelTips (state, payload) {//
      state.travelTips = payload
    },
    CLEAR_TRSEARCHINFO (state) {
      state.trSearchInfo = initialState()
      state.travelerList = []
      state.travelTips={
        lastDate: '',
        depportCityid:'',
        arriveCityid:'',
      }
    },
    subsequent (state, payload) {
      state.subsequent = payload
    },
  },
  actions: {
    /**
     * 获取预订流程的参数
     * 3. 系统级 - 火车票预订12306账号是否必填 11603007
     */
    async getPageParameter ({ state }) {
      const PageParameter = await TrainBookInteractor.getOfflineBook()
      state.trSearchInfo.PageParameter = PageParameter
    },
    async getLast12306Account ({ state }) {
      if (!state.trSearchInfo['12306Info'].trainAccount) {
        const { trainAccount, password } = await TrainBookInteractor.getLast12306Account()
        state.trSearchInfo['12306Info'].trainAccount = trainAccount
        state.trSearchInfo['12306Info'].password = password

        return { trainAccount, password }
      }

      return {}
    },
    /**
     * 获取当前12306账号的常旅客
     * 匹配当前所选出行人 在不在12306账号的常旅客中
     * 不在的给提示: psg上的 `isNotAccount` 属性设为 true
     */
    async getAccountPsgList ({ state }) {
      return new Promise(async (resolve, reject) => {
        if (state.trSearchInfo['12306Info'].trainAccount) {
          try {
            const { data = [] } = await api['trQuery/FindClkList']({
              trainAccount: state.trSearchInfo['12306Info'].trainAccount,
              pass: state.trSearchInfo['12306Info'].password,
              captchaCode:state.trSearchInfo['12306Info'].verificateCode,
            })
            state.trSearchInfo['12306Info'].verificateCode=''
            data.forEach(psg => {
              psg.born = psg.birthday
              psg.expiryDate = psg.getValidDateEnd
              psg.phoneNumber = psg.phone
              psg.checked = false
              psg.passed = psg.checkStatus == 0 && psg.phoneCheckStatus == 0 && psg.phone
            })
		
            state.trSearchInfo['12306Info'].psgList = data
		
            state.travelerList.forEach((traver, i) => {
              if (traver.psgType != 2) {
                let psg = data.find(psg => {
                  if (psg.name == filters.getName(traver)) {
                    psg.checked = true
                    state.travelerList.splice(i, 1, psg)
                    return true
                  }
                  return false
                })
			
                // 常旅客不在 当前 12306 账号的常旅客里面
                // 有可能是员工 转换一下数据格式，可以正常显示即可
                if (!psg) {
                  if (!traver.name) {
                    Vue.set(traver, 'name', filters.getName(traver))
                    Vue.set(traver, 'identyType', filters.getIdType(traver))
                    Vue.set(traver, 'identy', filters.getIdNumber2(traver))
                  }
                  Vue.set(traver, 'isNotAccount', true)
                }
              }
            })
            resolve(data)
          }catch (error) {
            reject(error)
          }
			
	
	
        }
				
      })
		
    },
  }
}
export default tr